// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2whYJ","header":"MessagesList_header__Y3q2Q","chat":"MessagesList_chat__1RNR_"};